import { sendFirebaseEvent, setUserId } from './firebase';
import { sendAFEvent, setAFCustomerId } from './appsflyer';
import { sendAmplitudeData, setAmplitudeUserId } from './amplitude';
import { sendLockerStudioData } from './lockerStudio';
import biEvents from './biEvents';

const isStage = process.env.REACT_APP_ENV === 'stage';

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
  const biEventName = biEvents[eventName] || eventName;

  sendFirebaseEvent(eventName, eventParams);
  sendAFEvent(eventName, eventParams);
  sendAmplitudeData(eventName, eventParams);
  sendLockerStudioData(biEventName, eventParams);
  pushGoogleTag(eventName, eventParams);
};

export const setAnalyticsUserId = (userId = '') => {
  setAmplitudeUserId(userId);
  setAFCustomerId(userId);
  setUserId(userId);
};

export const pushGoogleTag = (eventName, eventParams) => {
  if (isStage) return;
  window.gtag?.('event', eventName, eventParams);
};

export const pushFBEvent = (data, eventId) => {
  if (window.fbq) {
    window.fbq('track', `Purchase${isStage ? '_test' : ''}`, data, {
      eventID: eventId,
    });
  }
};
